export const select = {
  styleOverrides: {
    select: {
      '&:focus': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)'
      }
    }
  }
};
